import { APP_ENV } from '@/env';

export const OAUTH_LOGIN_HOST = {
  production: 'account.realworld.to',
  development: 'account-test.realworld.to',
  staging: 'account-staging.realworld.to'
}[APP_ENV];

/** BeltBanner 컴포넌트의 높이 (px) */
export const BELT_BANNER_HEIGHT = 58;
